export { shouldLinkExternally } from '../utils/url';
export { disableZoomTransition } from '../link/zoom/ZoomTransitionEnabler';
